import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.knowledge_graph');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-page-knowledge_graph',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.knowledge_graph/view.scss */
:host {
  display: block;
  min-height: calc(100dvh - var(--workspace-header-height, 64px));
  color: var(--ui-ink);
  background: var(--ui-canvas);
}

*, *::before, *::after {
  box-sizing: border-box;
}

.knowledge-content {
  --line:var(--ui-line);
  --muted:var(--ui-muted);
  max-width: 1680px;
  margin: auto;
  padding: 16px var(--workspace-gutter, 16px) 24px;
  font-size: 13px;
  font-weight: 400;
}

h1, h2, h3, h4, p {
  margin: 0;
}

h1 {
  font-size: 22px;
  line-height: 1.3;
  font-weight: 750;
  letter-spacing: -0.025em;
}

h2 {
  font-size: 18px;
  line-height: 1.5;
  font-weight: 700;
}

h3 {
  font-size: 16px;
  font-weight: 700;
}

h4 {
  font-size: 15px;
  font-weight: 650;
}

p {
  line-height: 1.65;
}

small {
  display: block;
  font-size: 13px;
  color: var(--muted);
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.muted {
  color: var(--muted);
}

.knowledge-content .page-heading .page-description {
  margin-top: 0;
  color: var(--muted);
  font-size: 13px;
  font-weight: 400;
}

.page-heading, .section-heading, .run-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.page-heading {
  margin-bottom: 12px;
  align-items: center;
}

.page-heading > div:first-child {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
}

.heading-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.heading-actions a {
  text-decoration: none;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 7px 12px;
  min-height: 36px;
  font: inherit;
  font-weight: 650;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
}

.primary {
  background: var(--ui-accent);
  color: var(--ui-paper);
}

.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}

.secondary {
  background: var(--ui-paper);
  color: var(--ui-text);
  border-color: var(--ui-control);
}

.secondary:hover:not(:disabled) {
  background: var(--ui-selected);
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible, summary:focus-visible, [tabindex]:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.text-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  color: var(--ui-accent);
  border: 0;
  background: transparent;
  padding: 8px;
  cursor: pointer;
}

.text-button:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

a {
  color: var(--ui-accent);
  text-underline-offset: 4px;
}

input, select, textarea {
  width: 100%;
  min-height: 36px;
  padding: 7px 10px;
  border: 1px solid var(--ui-control);
  border-radius: 6px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  font: inherit;
  caret-color: var(--ui-accent);
}

input::placeholder {
  color: var(--muted);
  opacity: 1;
}

select {
  appearance: auto;
  -webkit-appearance: auto;
  background-image: none;
  padding-right: 28px;
}

textarea {
  resize: vertical;
  line-height: 1.6;
}

input[type=checkbox] {
  width: 18px;
  min-height: 18px;
  height: 18px;
  accent-color: var(--ui-accent);
}

label {
  font-weight: 650;
}

label input, label textarea {
  margin-top: 6px;
  font-weight: 500;
}

.search-input {
  display: flex;
  flex: 1;
  align-items: center;
  position: relative;
  min-width: 0;
}

.search-input input {
  margin: 0;
  padding-left: 40px;
}

.search-input i {
  position: absolute;
  left: 14px;
  color: var(--muted);
}

.section-heading span {
  color: var(--ui-accent);
  margin-left: 8px;
}

.empty, .inline-empty, .loading {
  padding: 28px 16px;
  color: var(--muted);
  text-align: center;
}

.empty h2 {
  color: var(--ui-ink);
}

.empty p {
  margin-top: 12px;
}

.message {
  margin: 12px 0;
  padding: 12px 16px;
  background: var(--ui-selected);
  color: var(--ui-text);
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.message.error {
  background: #fff3f4;
  color: var(--ui-danger);
}

.message.warning {
  background: #fff4e3;
  color: var(--ui-warning);
}

.recovery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.register {
  background: var(--ui-paper);
  border: 0;
  border-radius: var(--ui-radius);
  overflow: hidden;
}

.register-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--line);
}

.register-toolbar > div {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.register-toolbar h2 {
  font-size: 19px;
  letter-spacing: -0.02em;
}

.register-toolbar h2 span {
  color: var(--ui-accent);
  margin-left: 8px;
  font-variant-numeric: tabular-nums;
}

.register-toolbar p {
  font-size: 13px;
  margin-top: 2px;
}

.register-search {
  margin-left: auto;
  max-width: 340px;
}

.document-jobs {
  margin: 0;
  border-bottom: 1px solid var(--line);
}

.document-jobs:last-of-type {
  border-bottom: 0;
}

.document-jobs > summary {
  display: list-item;
  cursor: pointer;
  padding: 14px 20px;
  line-height: 1.6;
  color: var(--ui-text);
}

.document-jobs > summary:hover {
  background: var(--ui-soft);
}

.document-jobs[open] > summary {
  background: var(--ui-soft);
}

.document-title {
  font-size: 15px;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.document-title i {
  margin: 0 10px 0 4px;
  color: var(--ui-muted);
}

.document-count {
  display: inline-block;
  margin: 0 0 0 16px;
  color: var(--muted);
  font-size: 13px;
}

.group-documents {
  padding: 8px 16px;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.document-job-heading, .document-job {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px 120px 180px 110px;
  align-items: center;
  gap: 12px;
  padding: 8px 16px 8px 46px;
}

.document-job-heading {
  font-size: 13px;
  color: var(--muted);
  background: var(--ui-paper);
}

.document-job {
  min-height: 44px;
  border-top: 1px solid transparent;
  font-variant-numeric: tabular-nums;
}

.document-job:hover {
  background: var(--ui-soft);
}

.document-job.last-job {
  background: var(--ui-selected);
}

.job-range {
  min-width: 0;
  overflow-wrap: anywhere;
}

.job-range strong {
  font-weight: 650;
}

.document-job time {
  font-size: 13px;
  color: var(--muted);
}

.mobile-label {
  display: none;
}

.state {
  display: inline-block;
  border-radius: 5px;
  padding: 2px 7px;
  color: var(--ui-accent);
  background: var(--ui-selected);
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}

.state.held {
  color: var(--ui-warning);
  background: #fff4e3;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 0;
  border-top: 1px solid var(--line);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.pagination > span:first-child {
  margin-right: auto;
  color: var(--muted);
}

.pagination .button {
  min-height: 36px;
  padding: 6px 10px;
  font-size: 13px;
}

.register > .pagination {
  justify-content: flex-end;
}

.job-context {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px 4px;
  border: 0;
  border-radius: var(--ui-radius) var(--ui-radius) 0 0;
  background: var(--ui-paper);
  color: var(--ui-ink);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.job-context i {
  padding-top: 4px;
}

.run-summary {
  background: var(--ui-paper);
  border: 0;
  border-radius: 0 0 var(--ui-radius) var(--ui-radius);
  padding: 2px 16px 8px;
  margin-bottom: 12px;
  font-size: 13px;
}

.run-copy, .run-actions {
  display: flex;
  gap: 8px 16px;
  align-items: center;
  flex-wrap: wrap;
}

.run-copy strong {
  color: var(--ui-ink);
}

.run-copy span {
  color: var(--muted);
}

progress {
  width: 140px;
  height: 4px;
  border: 0;
  accent-color: var(--ui-accent);
}

progress::-webkit-progress-bar {
  background: var(--ui-line);
}

progress::-webkit-progress-value {
  background: var(--ui-accent);
}

.candidate-workspace, .candidate-workspace.has-inspector {
  display: grid;
  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);
  gap: 0;
  border: 0;
  border-radius: var(--ui-radius);
  background: var(--ui-paper);
  overflow: hidden;
  min-height: 0;
}

.candidate-list {
  background: var(--ui-paper);
  min-width: 0;
  border-right: 1px solid var(--line);
  display: flex;
  flex-direction: column;
}

.work-navigation {
  display: flex;
  align-items: stretch;
  gap: 4px;
  padding: 8px;
  border-bottom: 1px solid var(--line);
  background: var(--ui-paper);
}

.work-navigation button {
  flex: 1;
  background: none;
  border: 0;
  border-radius: 7px;
  color: var(--muted);
  min-height: 36px;
  font: inherit;
  font-weight: 650;
  padding: 8px 6px;
  cursor: pointer;
  white-space: nowrap;
}

.work-navigation button.active {
  color: var(--ui-accent);
  background: var(--ui-selected);
}

.work-navigation span {
  margin-left: 4px;
  font-size: 13px;
}

.search-toolbar {
  display: flex;
  gap: 8px;
  padding: 10px 12px 6px;
  flex-wrap: wrap;
  align-items: center;
}

.search-toolbar .search-input {
  flex-basis: calc(100% - 80px);
}

.search-toolbar .button {
  font-size: 13px;
  padding: 6px 10px;
}

.search-toolbar > .secondary {
  width: 100%;
  justify-content: flex-start;
  border: 0;
  padding: 4px 0;
  min-height: 32px;
}

.filter-panel {
  display: grid;
  gap: 8px;
  padding: 10px 12px;
  background: var(--ui-soft);
  border-block: 1px solid var(--line);
}

.filter-panel label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
}

.filter-panel .text-button {
  justify-self: end;
}

.review-note {
  font-size: 13px;
  line-height: 1.6;
  color: var(--muted);
  margin: 8px 0 12px;
}

.candidate-list > .review-note, .candidate-list .search-toolbar ~ .review-note {
  padding: 0 12px;
  margin: 0 0 8px;
}

.candidate-table {
  flex: 1;
  max-height: min(560px, 100dvh - var(--workspace-header-height, 0px) - 220px);
  min-height: 220px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.candidate-name {
  color: var(--ui-accent);
  font: inherit;
  font-weight: 650;
  cursor: pointer;
  background: none;
  border: 0;
  text-align: left;
  overflow-wrap: anywhere;
}

.candidate-row {
  display: block;
  width: 100%;
  padding: 12px;
  border-bottom: 1px solid transparent;
  color: var(--ui-ink);
}

.candidate-row:hover {
  background: var(--ui-soft);
}

.candidate-row.selected {
  background: var(--ui-selected);
}

.candidate-row.selected strong {
  color: var(--ui-accent);
}

.candidate-row-top {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  line-height: 1.55;
}

.candidate-row-top strong {
  font-size: 15px;
  font-weight: 700;
}

.candidate-row-top i {
  font-size: 11px;
  color: var(--ui-muted);
}

.candidate-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  margin-top: 4px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 400;
}

.candidate-check {
  margin-left: auto;
  color: var(--ui-accent);
}

.candidate-check.held {
  color: var(--ui-warning);
}

.candidate-source {
  display: block;
  color: var(--muted);
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
}

.inspector {
  background: var(--ui-paper);
  min-width: 0;
  max-height: min(800px, 100dvh - var(--workspace-header-height, 0px) - 48px);
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
  padding: 0 24px 24px;
  scroll-padding-block: 16px;
  scroll-margin-top: calc(var(--workspace-header-height, 64px) + 16px);
}

.inspector-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid var(--line);
  margin-bottom: 12px;
  background: var(--ui-paper);
}

.inspector-navigation > div {
  display: flex;
  gap: 8px;
}

.inspector-heading {
  margin-bottom: 8px;
  align-items: flex-start;
}

.inspector-heading h2 {
  font-size: 24px;
  line-height: 1.4;
  letter-spacing: -0.025em;
  overflow-wrap: anywhere;
}

.inspector-heading > .text-button {
  display: none;
}

.inspector > .muted {
  font-size: 13px;
}

dl {
  margin: 12px 0;
}

dl > div {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 10px;
  padding: 4px 0;
  font-size: 13px;
}

dt {
  color: var(--muted);
  font-weight: 600;
}

dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.evidence-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0 8px;
}

.evidence-label > span {
  font-size: 13px;
  color: var(--muted);
}

.evidence {
  padding: 12px 0;
  border-top: 1px solid var(--line);
}

.evidence h4 {
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.evidence small {
  margin: 4px 0 12px;
}

blockquote {
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.8;
  padding: 16px 18px;
  border: 0;
  border-radius: 10px;
  background: var(--ui-soft);
  margin: 0 0 16px;
}

.evidence a {
  font-size: 13px;
  font-weight: 650;
}

details {
  margin-top: 8px;
}

summary {
  cursor: pointer;
  color: var(--ui-text);
  min-height: 36px;
  padding-block: 7px;
}

.evidence-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  line-height: 1.85;
  margin-top: 12px;
}

.review-form {
  padding: 12px 16px;
  border: 0;
  border-radius: var(--ui-radius);
  margin-top: 16px;
  background: var(--ui-soft);
}

.review-form > summary {
  font-size: 15px;
  font-weight: 700;
  color: var(--ui-accent);
  min-height: 36px;
  padding: 4px 0;
}

.review-editor {
  padding-top: 12px;
}

.review-form label {
  display: block;
  margin-bottom: 16px;
}

.review-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.review-actions .button {
  white-space: normal;
}

.review-history {
  padding-left: 20px;
}

.review-history li {
  margin: 12px 0;
  font-size: 14px;
}

.review-welcome {
  background: var(--ui-paper);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  text-align: center;
  padding: 24px;
  color: var(--muted);
}

.review-welcome > i {
  font-size: 32px;
  color: var(--ui-accent);
  margin-bottom: 20px;
}

.review-welcome h2 {
  color: var(--ui-text);
}

.review-welcome p {
  margin: 12px 0 24px;
}

.review-welcome > span {
  font-size: 14px;
}

.error-details {
  padding: 12px;
  background: #fff4e3;
  margin: 12px 0;
  color: var(--ui-warning);
}

.creation {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 1440px;
  background: var(--ui-paper);
  border-radius: var(--ui-radius);
  overflow: clip;
}

.creation-main {
  width: 100%;
  padding: 24px;
  border: 0;
  background: var(--ui-paper);
  min-width: 0;
}

.step-heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.step-heading p {
  font-size: 13px;
  margin-top: 4px;
}

.job-name {
  display: block;
  margin-bottom: 16px;
}

.creation .section-heading {
  margin-bottom: 12px;
}

.source-empty {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 4px 16px;
  background: var(--ui-soft);
  border: 0;
  border-radius: 8px;
  padding: 20px;
  text-align: left;
}

.source-empty > i {
  grid-column: 1;
  grid-row: 1/3;
}

.source-empty h3, .source-empty p {
  grid-column: 2;
}

.source-empty .button {
  grid-column: 3;
  grid-row: 1/3;
}

.source-empty > i {
  font-size: 26px;
  color: var(--ui-accent);
  margin: 0;
}

.source-empty p {
  color: var(--muted);
  margin: 0;
}

.selected-sources {
  list-style: none;
  margin: 0;
  padding: 0;
}

.selected-sources li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--line);
}

.selected-sources li > div {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.folder-icon {
  color: #a87510;
}

.range {
  width: 140px;
  font-size: 14px;
}

.prepare-heading {
  border-top: 1px solid var(--line);
  margin: 20px 0 12px;
  padding-top: 16px;
}

.prepare-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.prepare-actions .muted {
  font-size: 14px;
}

.creation-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 24px;
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid var(--ui-line);
  background: var(--ui-paper);
  position: static;
}

.creation-summary dl {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 0;
  padding: 0;
  border: 0;
}

.creation-summary dl > div {
  display: flex;
  gap: 8px;
}

.creation-summary dl dt {
  color: var(--ui-muted);
}

.creation-summary dl dd {
  margin: 0;
  color: var(--ui-ink);
  font-weight: 650;
}

.creation-summary p {
  flex-basis: 100%;
  font-size: 13px;
  color: var(--muted);
}

.creation-summary .cost-note {
  margin: 0;
  font-size: 13px;
}

.creation-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  width: 100%;
  margin: 4px 0 0;
}

.creation-footer .button {
  order: 2;
  margin-left: auto;
  min-height: 44px;
}

.creation-footer small {
  order: 1;
  margin: 0;
}

.table-wrap {
  overflow: auto;
  min-width: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  text-align: left;
}

th, td {
  padding: 12px;
  border-bottom: 1px solid var(--line);
  overflow-wrap: anywhere;
}

th {
  background: var(--ui-soft);
  font-weight: 650;
}

td {
  line-height: 1.6;
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.source-picker {
  width: min(1240px, 100vw - 64px);
  max-width: none;
  height: min(800px, 100dvh - 64px);
  max-height: calc(100dvh - 32px);
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  margin: auto;
  box-shadow: 0 24px 72px rgba(35, 39, 47, 0.25);
  overflow: hidden;
}

.source-picker[open] {
  display: flex;
  flex-direction: column;
}

.source-picker::backdrop {
  background: rgba(35, 39, 47, 0.44);
}

.picker-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.picker-header h2 {
  font-size: 20px;
  margin: 0;
}

.picker-header p {
  color: var(--ui-muted);
  margin-top: 4px;
}

.picker-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 6px;
  color: var(--ui-text);
  background: transparent;
  cursor: pointer;
}

.picker-check {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  cursor: pointer;
}

.picker-check input[type=checkbox] {
  width: 18px;
  height: 18px;
  min-height: 18px;
  margin: 0;
  padding: 0;
  flex: none;
}

.picker-close:hover:not(:disabled) {
  background: var(--ui-selected);
}

.picker-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  flex: 1;
  min-height: 0;
}

.picker-browser {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 10px 16px 0;
}

.picker-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  flex-shrink: 0;
  min-height: 44px;
}

.picker-breadcrumbs button {
  padding: 8px 4px;
  background: transparent;
  border: 0;
  color: var(--ui-accent);
  flex-shrink: 0;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.picker-breadcrumbs button[aria-current] {
  color: var(--ui-ink);
  font-weight: 600;
}

.picker-search {
  display: flex;
  gap: 8px;
  margin: 8px 0 12px;
  flex-shrink: 0;
}

.picker-search input {
  min-width: 0;
}

.picker-files {
  flex: 1;
  overflow: auto;
  min-height: 0;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.picker-column-heading, .picker-file-row {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 112px;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
}

.picker-column-heading {
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.picker-file-row {
  min-height: 54px;
  border-bottom: 1px solid var(--ui-line);
}

.picker-file-row:hover {
  background: var(--ui-soft);
}

.picker-file-row.picker-checked {
  background: var(--ui-selected);
}

.picker-file-name {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  color: var(--ui-ink);
  border: 0;
  background: transparent;
  min-width: 0;
  min-height: 44px;
  padding: 6px 0;
  cursor: pointer;
}

.picker-file-name span {
  overflow-wrap: anywhere;
  flex: 1;
}

.picker-file-name .fa-chevron-right {
  font-size: 11px;
  color: var(--ui-muted);
}

.picker-file-name .fa-file-pdf {
  color: #c83c46;
}

.picker-file-state {
  color: var(--ui-muted);
  font-size: 14px;
}

.picker-parent {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 48px;
  padding: 10px 12px 10px 44px;
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--ui-accent);
  cursor: pointer;
  text-align: left;
}

.picker-parent:hover {
  background: var(--ui-soft);
}

.picker-empty {
  padding: 40px 12px;
  color: var(--ui-muted);
  flex: 1;
}

.picker-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  color: var(--ui-muted);
  flex-shrink: 0;
  font-size: 14px;
}

.picker-pagination > div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.picker-pagination .button {
  padding: 7px 10px;
  min-height: 44px;
}

.picker-selection {
  border-left: 1px solid var(--ui-line);
  padding: 20px;
  overflow: auto;
  background: var(--ui-soft);
  min-width: 0;
}

.picker-selection h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 14px;
}

.picker-selection h3 span {
  color: var(--ui-accent);
  margin-left: 8px;
}

.picker-selection p {
  color: var(--ui-muted);
  font-size: 14px;
}

.picker-selection ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.picker-selection li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.picker-selection li > div {
  flex: 1;
  min-width: 0;
}

.picker-selection strong {
  font-size: 14px;
  font-weight: 550;
  overflow-wrap: anywhere;
}

.picker-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 20px;
  border-top: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.picker-footer > div {
  display: flex;
  gap: 8px;
}

.picker-folder-note {
  color: var(--ui-muted);
  font-size: 14px;
}

@media (max-width: 767px) {
  .source-picker {
    width: calc(100vw - 16px);
    height: calc(100dvh - 24px);
    max-height: calc(100dvh - 16px);
  }
  .picker-header {
    padding: 16px;
    gap: 8px;
  }
  .picker-header h2 {
    font-size: 18px;
  }
  .picker-header p {
    font-size: 14px;
  }
  .picker-body {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .picker-browser {
    padding: 8px 12px 0;
    flex: 1 0 300px;
  }
  .picker-selection {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    padding: 12px 16px;
    max-height: 160px;
    flex-shrink: 0;
  }
  .picker-selection h3 {
    margin-bottom: 6px;
  }
  .picker-selection li {
    padding: 8px 0;
  }
  .picker-column-heading, .picker-file-row {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 8px;
    padding: 10px 8px;
  }
  .picker-column-heading > span:last-child {
    display: none;
  }
  .picker-file-state {
    grid-column: 2;
    margin-top: -6px;
  }
  .picker-footer {
    padding: 12px;
    gap: 8px;
    flex-wrap: wrap;
  }
  .picker-footer > div {
    margin-left: auto;
  }
  .picker-folder-note {
    display: none;
  }
  .picker-pagination {
    gap: 6px;
  }
}
.graph-panel {
  min-width: 0;
}

.graph-concepts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0;
}

.graph-concepts .button {
  white-space: normal;
  text-align: left;
  overflow-wrap: anywhere;
}

.graph-concepts .active {
  border-color: var(--ui-accent);
  background: var(--ui-selected);
}

.graph-concepts small {
  margin: 0;
  font-weight: 500;
}

.graph-drawing {
  margin: 24px 0;
  padding: 16px 0;
  border-top: 1px solid var(--ui-line);
  border-bottom: 1px solid var(--ui-line);
  overflow: auto;
}

.graph-drawing svg {
  display: block;
  width: 100%;
  max-width: 900px;
  min-width: 620px;
  margin: auto;
}

.graph-drawing line {
  stroke: var(--ui-control);
  stroke-width: 1.5;
}

.graph-drawing rect {
  fill: var(--ui-soft);
  stroke: var(--ui-line);
}

.graph-drawing .graph-root {
  fill: var(--ui-selected);
  stroke: var(--ui-accent);
}

.graph-drawing text {
  text-anchor: middle;
  font-size: 15px;
  fill: var(--ui-ink);
}

.graph-drawing .graph-edge-label {
  font-size: 14px;
  fill: var(--ui-muted);
  stroke: var(--ui-paper);
  stroke-width: 5px;
  paint-order: stroke;
}

.graph-claims {
  list-style: none;
  padding: 0;
  margin: 16px 0;
}

.graph-claims li {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-line);
}

.graph-claims .candidate-name {
  flex: 1 1 200px;
}

.graph-claims span {
  color: var(--ui-muted);
}

@media (max-width: 767px) {
  .graph-drawing {
    display: none;
  }
  .review-actions .button {
    white-space: normal;
    text-align: left;
  }
}
.graph-scope {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-bottom: 12px;
}

.graph-scope select {
  max-width: 100%;
}

.graph-drawing line.conditional {
  stroke-dasharray: 6 4;
}

.graph-panel {
  padding: 12px;
}

.graph-panel .candidate-name {
  font-size: 16px;
}

.graph-panel .graph-scope {
  align-items: stretch;
  flex-direction: column;
}

.graph-panel .filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.graph-panel .concept-select {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}

.graph-panel .graph-claims {
  max-height: 480px;
  overflow: auto;
}

.graph-panel .graph-drawing {
  margin-block: 16px;
  padding: 12px 0;
}

.graph-panel .graph-drawing svg {
  min-width: 620px;
}

@media (min-width: 761px) and (max-width: 1100px) {
  .knowledge-content {
    padding-inline: var(--workspace-gutter, 20px);
  }
  .candidate-workspace, .candidate-workspace.has-inspector {
    grid-template-columns: 300px minmax(0, 1fr);
  }
  .inspector {
    padding-inline: 20px;
  }
  .inspector-heading h2 {
    font-size: 22px;
  }
  .document-job-heading, .document-job {
    grid-template-columns: minmax(0, 1fr) 120px 90px 150px 100px;
    gap: 8px;
    padding-left: 24px;
  }
  .creation {
    grid-template-columns: minmax(0, 1fr) 280px;
    gap: 16px;
  }
  .creation-main {
    padding: 20px;
  }
  .heading-actions .button {
    font-size: 14px;
    padding-inline: 12px;
  }
}
@media (max-width: 760px) {
  .knowledge-content {
    padding: 12px var(--workspace-gutter, 12px) 20px;
  }
  .page-heading {
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }
  h1 {
    font-size: 20px;
  }
  .heading-actions {
    width: 100%;
  }
  .heading-actions .button {
    flex: 1;
  }
  .page-description {
    font-size: 15px;
  }
  .review-page .page-heading {
    align-items: center;
  }
  .review-page .heading-actions {
    width: auto;
  }
  .review-page .heading-actions .button {
    padding: 8px 10px;
    font-size: 14px;
  }
  .review-page .heading-actions a {
    display: none;
  }
  .register-toolbar {
    flex-wrap: wrap;
    padding: 12px;
    gap: 8px;
  }
  .register-toolbar > div {
    flex: 1;
  }
  .register-search {
    order: 3;
    flex-basis: 100%;
    max-width: none;
  }
  .document-jobs > summary {
    padding: 12px;
  }
  .document-title {
    font-size: 14px;
  }
  .document-title i {
    display: none;
  }
  .document-count {
    display: block;
    margin: 4px 0 0 18px;
  }
  .document-job-heading {
    display: none;
  }
  .document-job {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 16px;
    padding: 12px 16px;
  }
  .job-range {
    grid-column: 1;
    grid-row: 1;
  }
  .job-status {
    grid-column: 2;
    grid-row: 1;
  }
  .job-count {
    grid-column: 1;
    grid-row: 2;
    font-size: 14px;
    color: var(--muted);
  }
  .document-job time {
    grid-column: 1;
    grid-row: 3;
    font-size: 13px;
  }
  .job-open {
    grid-column: 2;
    grid-row: 2/4;
  }
  .mobile-label {
    display: inline;
  }
  .job-context {
    font-size: 14px;
    padding: 12px;
  }
  .run-summary {
    padding: 4px 12px;
    gap: 8px;
    align-items: flex-start;
  }
  .run-copy {
    padding: 8px 0;
    gap: 4px 12px;
  }
  .run-actions {
    gap: 4px;
  }
  .run-summary .text-button {
    font-size: 13px;
    padding: 8px 0;
  }
  .candidate-workspace, .candidate-workspace.has-inspector {
    display: block;
    min-height: 0;
  }
  .candidate-list {
    border: 0;
  }
  .candidate-workspace.has-inspector .candidate-list {
    display: none;
  }
  .candidate-table {
    max-height: min(600px, 65dvh);
  }
  .candidate-row {
    padding: 12px;
  }
  .work-navigation {
    padding: 8px;
  }
  .search-toolbar > .secondary {
    width: auto;
  }
  .review-welcome {
    display: none;
  }
  .inspector {
    max-height: none;
    padding: 0 16px 20px;
  }
  .inspector-navigation {
    margin-bottom: 16px;
  }
  .inspector-heading h2 {
    font-size: 20px;
  }
  blockquote {
    padding: 16px;
    font-size: 16px;
  }
  .review-form {
    padding: 14px;
  }
  .creation {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .creation-main {
    padding: 20px 16px;
    width: 100%;
  }
  .creation-summary {
    position: static;
    width: 100%;
    padding: 20px;
  }
  .step-heading {
    gap: 10px;
  }
  .step-heading h2 {
    font-size: 19px;
  }
  .creation .section-heading .button {
    font-size: 14px;
    padding: 8px 12px;
  }
  .selected-sources li {
    flex-wrap: wrap;
  }
  .range {
    width: 100%;
  }
  .recovery {
    flex-direction: column;
    align-items: stretch;
  }
  .review-actions .button {
    font-size: 14px;
  }
  .graph-panel .graph-drawing {
    display: block;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    transition: none !important;
  }
}
/* Workspace navigation height is shared with the responsive authoring shell. */
.knowledge-content {
  font-family: Pretendard, "Noto Sans KR", sans-serif;
}

.button, .text-button {
  font-size: 13px;
}

.button {
  transition: background-color 0.15s, border-color 0.15s;
}

.message, .error-details {
  border-radius: 8px;
}

.document-title {
  color: var(--ui-ink);
}

.evidence-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
}

@media (min-width: 961px) and (max-width: 1280px) {
  .document-job-heading, .document-job {
    grid-template-columns: minmax(0, 1fr) 110px 80px 140px 96px;
    gap: 8px;
    padding-left: 24px;
  }
  .candidate-workspace, .candidate-workspace.has-inspector {
    grid-template-columns: 290px minmax(0, 1fr);
  }
  .inspector {
    padding-inline: 20px;
  }
  .creation {
    grid-template-columns: minmax(0, 1fr) 270px;
    gap: 16px;
  }
  .creation-main {
    padding: 16px;
  }
}
@media (max-width: 760px) {
  .knowledge-content {
    padding: 12px var(--workspace-gutter, 12px) 20px;
  }
  .knowledge-content .page-heading .page-description {
    font-size: 14px;
  }
  .heading-actions {
    flex-wrap: wrap;
  }
  .heading-actions .button {
    white-space: normal;
    text-align: center;
  }
  .review-page .heading-actions {
    flex-shrink: 1;
  }
  .document-title {
    line-height: 1.65;
  }
}
@media (prefers-reduced-motion: reduce) {
  .button {
    transition: none;
  }
}
/* Short windows keep evidence and form controls in the document flow. */
@media (max-height: 700px) {
  .candidate-workspace, .candidate-workspace.has-inspector {
    min-height: 0;
  }
  .inspector {
    max-height: none;
    overflow: visible;
  }
  .creation-summary {
    position: static;
  }
  .source-picker {
    height: calc(100dvh - 24px);
    max-height: calc(100dvh - 16px);
  }
  .picker-header {
    padding: 12px 20px;
  }
  .picker-footer {
    padding: 10px 20px;
  }
}
.knowledge-content :is(button, a, input, textarea, select, summary) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 16px);
  scroll-margin-bottom: 16px;
}

@media (pointer: coarse), (max-width: 760px) {
  .knowledge-content :is(.button, .text-button, .work-navigation button, summary) {
    min-height: 44px;
  }
  .knowledge-content :is(input:not([type=checkbox]), select, textarea) {
    min-height: 44px;
    font-size: 16px;
  }
}
/* Connection recovery is distinct from a confirmed permission restriction. */
.bootstrap-recovery {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.bootstrap-recovery > span {
  flex: 1 1 240px;
  overflow-wrap: anywhere;
}

.bootstrap-recovery > .button {
  flex-shrink: 0;
}

/* Review state stays separate from extraction progress and automatic checks. */
.job-review-counts {
  grid-column: 1/-1;
  grid-row: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 14px;
  color: var(--muted);
  font-size: 12px;
  padding-bottom: 4px;
}

.document-job .job-open {
  grid-column: 5;
  grid-row: 1;
}

.review-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: -4px 0 12px;
  padding: 0 16px;
  color: var(--muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.review-summary strong {
  color: var(--ui-text);
  font-weight: 600;
}

.candidate-quality {
  flex-basis: 100%;
  color: var(--ui-warning);
  font-size: 12px;
}

.inspector-navigation > div {
  align-items: center;
}

.inspector-navigation small {
  font-size: 12px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 760px) {
  .job-review-counts {
    grid-column: 1/-1;
    grid-row: 4;
    gap: 2px 12px;
    padding-bottom: 0;
  }
  .document-job .job-open {
    grid-column: 2;
    grid-row: 2/4;
  }
  .review-summary {
    gap: 4px 12px;
    padding: 0 12px;
  }
  .review-summary > strong {
    flex-basis: 100%;
  }
  .inspector-navigation {
    gap: 4px;
  }
  .inspector-navigation .text-button {
    padding-inline: 4px;
    white-space: nowrap;
  }
  .inspector-navigation > div {
    gap: 2px;
  }
}
.input-scope-note {
  margin: 6px 0 10px;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.6;
}

.input-scope-inline {
  display: block;
  margin-top: 4px;
  color: var(--ui-text);
  font-size: 12px;
  line-height: 1.6;
}

/* Keep candidate and evidence locations stable when a task panel changes. */
.candidate-row.selected .candidate-row-top > i {
  color: var(--ui-accent);
}

@media (prefers-reduced-motion: no-preference) {
  .creation, .filter-panel, .inspector {
    animation: knowledge-panel-ready 180ms ease-out;
  }
  .work-navigation button, .candidate-row, .document-jobs > summary {
    transition: background-color var(--motion-fast, 120ms) var(--motion-ease, ease-out), color var(--motion-fast, 120ms) var(--motion-ease, ease-out);
  }
}
@keyframes knowledge-panel-ready {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
/* Readable job comparisons and a focused candidate reader. */
.knowledge-content {
  font-size: 14px;
}

.document-jobs > summary {
  padding-block: 16px;
}

.document-jobs > summary::marker {
  color: var(--ui-muted);
}

.document-title {
  font-size: 16px;
  font-weight: 700;
}

.document-count {
  float: right;
  margin-left: 20px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.document-job-heading, .document-job {
  grid-template-columns: minmax(120px, 1fr) 110px minmax(290px, 1.8fr) 145px 96px;
  padding-inline: 24px;
  gap: 12px;
}

.document-job-heading {
  padding-block: 10px;
}

.document-job {
  padding-block: 12px;
  border-top: 1px solid var(--ui-line);
}

.job-range strong, .job-count > strong {
  font-size: 15px;
  font-weight: 650;
}

.job-count {
  min-width: 0;
  font-variant-numeric: tabular-nums;
}

.job-count > strong {
  display: block;
}

.job-review-counts {
  display: flex;
  margin: 4px 0 0;
  padding: 0;
  gap: 2px 12px;
  font-size: 13px;
  line-height: 1.6;
}

.job-review-counts > span {
  white-space: nowrap;
}

.state-pending, [data-state=PENDING] {
  color: var(--ui-warning);
}

.state-ai, [data-state=AI_REVIEWED] {
  color: var(--ui-accent);
}

.state-approved, [data-state=APPROVED] {
  color: var(--ui-success);
}

.state-rejected, [data-state=REJECTED] {
  color: var(--ui-danger);
}

.state[data-state=COMPLETED] {
  background: var(--ui-success-soft);
  color: var(--ui-success);
}

.state[data-state=FAILED], .state[data-state=CANCELLED] {
  background: #fff3f4;
  color: var(--ui-danger);
}

.state[data-state=PAUSED], .state[data-state=NEEDS_ATTENTION] {
  background: #fff4e3;
  color: var(--ui-warning);
}

.run-summary {
  margin-bottom: 0;
  border-radius: 0;
  padding-bottom: 10px;
}

.review-summary {
  margin: 0 0 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--ui-line);
  border-radius: 0 0 var(--ui-radius) var(--ui-radius);
  background: var(--ui-paper);
  font-size: 13px;
  gap: 4px 16px;
}

.review-summary > strong {
  font-size: 14px;
  font-weight: 700;
}

.candidate-row {
  border-bottom: 1px solid var(--ui-line);
}

.candidate-row-top strong {
  font-size: 16px;
}

.selected-state {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  font-size: 14px;
  color: var(--ui-muted);
}

.selected-state > [data-state] {
  font-size: 13px;
  font-weight: 650;
}

.inspector dl > div {
  font-size: 14px;
}

.inspector blockquote {
  font-size: 17px;
}

.inspector .evidence a {
  font-size: 14px;
}

.candidate-quality, .inspector-navigation small {
  font-size: 13px;
}

@media (min-width: 761px) and (max-width: 1100px) {
  .document-job-heading, .document-job {
    grid-template-columns: minmax(100px, 1fr) 100px minmax(200px, 1.4fr) 116px 80px;
    gap: 8px;
    padding-inline: 16px;
  }
  .document-job time {
    font-size: 13px;
  }
  .job-review-counts {
    gap: 2px 8px;
  }
}
@media (max-width: 1050px) {
  .candidate-workspace, .candidate-workspace.has-inspector {
    grid-template-columns: minmax(0, 1fr);
  }
  .candidate-list {
    border-right: 0;
  }
  .candidate-workspace.has-inspector .candidate-list, .review-welcome {
    display: none;
  }
  .inspector {
    max-height: none;
    overflow: visible;
    padding-inline: 20px;
  }
}
@media (max-width: 760px) {
  .document-title {
    font-size: 15px;
  }
  .document-count {
    float: none;
    display: block;
    margin: 4px 0 0;
  }
  .document-job {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 12px;
    padding: 14px 16px;
  }
  .job-range {
    grid-column: 1;
    grid-row: 1;
  }
  .job-status {
    grid-column: 2;
    grid-row: 1;
  }
  .job-count {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .document-job time {
    grid-column: 1;
    grid-row: 3;
  }
  .document-job .job-open {
    grid-column: 2;
    grid-row: 3;
    min-height: 44px;
  }
  .job-review-counts {
    font-size: 13px;
  }
  .review-summary {
    padding: 10px 12px;
    gap: 6px 12px;
  }
  .review-summary > strong {
    flex-basis: 100%;
  }
  .inspector {
    padding-inline: 16px;
  }
  .inspector blockquote {
    font-size: 16px;
  }
}
/* Task navigation uses the same quiet underline as other workspaces. */
.work-navigation {
  padding: 0 8px;
}

.work-navigation button {
  min-height: 44px;
  border-radius: 0;
  border-bottom: 2px solid transparent;
  color: var(--ui-text);
}

.work-navigation button.active {
  color: var(--ui-accent);
  border-bottom-color: var(--ui-accent);
  background: transparent;
}

.inspector .evidence a {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding-block: 6px;
}

@media (max-width: 1100px) {
  .inspector .evidence a {
    min-height: 44px;
    padding-block: 8px;
  }
}
@media (max-width: 600px) {
  .creation .source-empty {
    grid-template-columns: 28px minmax(0, 1fr);
    padding: 16px;
  }
  .creation .source-empty .button {
    grid-column: 2;
    grid-row: 3;
    justify-self: start;
    margin-top: 8px;
    min-height: 44px;
  }
}
/* Knowledge: align the real form gutter and group each document/candidate record. */
:host, .knowledge-content {
  background: transparent;
}

.knowledge-content .page-heading > div:first-child {
  display: block;
}

.knowledge-content .page-heading .page-description {
  margin-top: 6px;
}

.knowledge-content .register {
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
  background: var(--ui-paper);
}

.knowledge-content .register-toolbar {
  padding: 18px 20px;
  border-color: var(--ui-line);
}

.knowledge-content .register-toolbar h2 {
  font-size: 16px;
  font-weight: 650;
}

.knowledge-content .document-jobs > summary {
  min-height: 56px;
  padding: 14px 20px;
  background: var(--ui-soft);
}

.knowledge-content .document-job {
  padding: 14px 20px;
  gap: 10px 16px;
  min-height: 72px;
  border-color: var(--ui-line);
}

.knowledge-content .creation {
  display: block;
  padding: 0;
  background: transparent;
  border: 0;
}

.knowledge-content .creation-main {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.knowledge-content .creation-main .step-heading {
  margin: 0 0 20px;
}

.knowledge-content .creation-main .job-name {
  max-width: 760px;
}

.knowledge-content .creation-main .section-heading {
  margin: 24px 0 12px;
}

.knowledge-content .creation-main .source-empty {
  padding: 20px;
  background: var(--ui-soft);
  border: 0;
  border-radius: 8px;
}

.knowledge-content .creation-main .prepare-heading {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--ui-line);
}

.knowledge-content .creation-summary {
  margin-top: 24px;
  padding: 20px 0 0;
  border: 0;
  border-top: 1px solid var(--ui-line);
  border-radius: 0;
  background: transparent;
}

.knowledge-content .creation-footer {
  margin-top: 20px;
  padding: 0;
  align-items: center;
  gap: 12px;
}

.knowledge-content .job-context {
  margin-bottom: 8px;
  gap: 8px;
  font-size: 14px;
  line-height: 1.6;
}

.knowledge-content .run-summary {
  padding: 12px 16px;
  margin-bottom: 12px;
  gap: 8px 16px;
  border-color: var(--ui-line);
}

.knowledge-content .run-copy {
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.knowledge-content .review-summary {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px 16px;
  padding: 12px 0;
  margin: 0 0 12px;
}

.knowledge-content .inspector {
  padding: 0;
  scroll-margin-top: calc(var(--workspace-header-height) + 16px);
}

.knowledge-content .inspector-navigation {
  padding: 8px 16px;
  gap: 8px;
}

.knowledge-content .inspector .inspector-heading {
  padding: 14px 20px;
  margin: 0;
  border-bottom: 1px solid var(--ui-line);
}

.knowledge-content .inspector > :is(p, dl, .evidence-label, .review-form, .evidence) {
  margin-left: 20px;
  margin-right: 20px;
}

.knowledge-content .inspector > .selected-state {
  margin-top: 14px;
  margin-bottom: 8px;
  gap: 8px;
}

.knowledge-content .inspector .concept-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  padding: 0;
  margin-top: 8px;
  margin-bottom: 12px;
}

.knowledge-content .inspector .concept-meta > div {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.knowledge-content .inspector .concept-meta dd {
  margin: 0;
}

.knowledge-content .inspector .evidence-label {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.knowledge-content .inspector .evidence-label h3 {
  font-size: 15px;
  margin: 0;
}

.knowledge-content .inspector .evidence {
  padding: 12px 0;
  border-top: 1px solid var(--ui-line);
}

.knowledge-content .inspector .evidence h4 {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
}

.knowledge-content .inspector .evidence > small {
  display: block;
  margin: 4px 0 8px;
}

.knowledge-content .inspector .evidence blockquote {
  margin: 10px 0;
  padding: 16px;
  border: 0;
  border-radius: 8px;
  background: var(--ui-soft);
  color: var(--ui-ink);
  font-size: 16px;
  line-height: 1.85;
}

.knowledge-content .inspector .review-note {
  margin-top: 6px;
  margin-bottom: 8px;
  font-size: 12px;
}

@media (max-width: 800px) {
  .knowledge-content .register-toolbar {
    padding: 14px;
  }
  .knowledge-content .document-jobs > summary {
    padding: 14px;
  }
  .knowledge-content .document-job {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px 12px;
    padding: 14px;
  }
  .knowledge-content .document-job > .job-range {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
  }
  .knowledge-content .document-job > .job-status {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
  }
  .knowledge-content .document-job > .job-count {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .knowledge-content .document-job > time {
    grid-column: 1;
    grid-row: 3;
    align-self: center;
  }
  .knowledge-content .document-job > .job-open {
    grid-column: 2;
    grid-row: 3;
    min-height: 44px;
    justify-self: end;
  }
  .knowledge-content .document-job .job-review-counts {
    gap: 4px 10px;
    margin-top: 5px;
  }
  .knowledge-content .run-summary {
    padding: 12px;
  }
  .knowledge-content .run-actions {
    gap: 4px 10px;
  }
  .knowledge-content .review-summary {
    gap: 6px 12px;
    font-size: 12px;
  }
  .knowledge-content .inspector .inspector-heading {
    padding: 12px 16px;
  }
  .knowledge-content .inspector > :is(p, dl, .evidence-label, .review-form, .evidence) {
    margin-left: 16px;
    margin-right: 16px;
  }
  .knowledge-content .inspector-navigation {
    gap: 4px;
    padding: 6px 12px;
  }
  .knowledge-content .inspector-navigation > div {
    gap: 4px;
  }
}
/* Job-wide context supports the selected candidate rather than preceding it in bands. */
.knowledge-content .job-status-details {
  border: 0;
  padding: 0;
  margin: 0 0 8px;
}

.knowledge-content .job-status-details > summary {
  display: none;
}

.knowledge-content .run-summary {
  padding: 8px 0;
  margin: 0 0 6px;
  border: 0;
  background: transparent;
}

.knowledge-content .review-summary {
  padding: 6px 0;
  margin: 0 0 8px;
}

.knowledge-content .inspector .evidence-revision {
  color: var(--ui-muted);
  font-size: 12px;
}

@media (max-width: 1100px) {
  .knowledge-content:has(.has-inspector) .job-status-details > summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 12px;
    min-height: 44px;
    color: var(--ui-text);
    font-size: 13px;
    cursor: pointer;
    list-style: none;
  }
  .job-status-details > summary::-webkit-details-marker {
    display: none;
  }
  .job-status-details > summary > span {
    margin-left: auto;
    color: var(--ui-muted);
    font-size: 12px;
  }
}
@media (max-width: 800px) {
  .knowledge-content .document-job .job-count {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 4px 12px;
  }
  .knowledge-content .document-job .job-count > strong {
    flex: none;
  }
  .knowledge-content .document-job .job-review-counts {
    display: inline-flex;
    flex: 1 1 180px;
    flex-wrap: wrap;
    gap: 4px 8px;
    margin: 0;
  }
  .knowledge-content .document-job .job-review-counts > span {
    white-space: nowrap;
  }
  .knowledge-content .inspector-navigation {
    padding-block: 4px;
  }
  .knowledge-content .inspector .inspector-heading {
    padding-block: 10px;
  }
}
/* A return action stays beside the mobile creation title. */
@media (max-width: 600px) {
  .knowledge-content.creation-page > .page-heading {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px 12px;
  }
  .knowledge-content.creation-page > .page-heading > div:first-child {
    display: contents;
  }
  .knowledge-content.creation-page > .page-heading h1 {
    grid-column: 1;
    grid-row: 1;
  }
  .knowledge-content.creation-page > .page-heading .page-description {
    grid-column: 1/-1;
    grid-row: 2;
    margin: 0;
  }
  .knowledge-content.creation-page > .page-heading .heading-actions {
    grid-column: 2;
    grid-row: 1;
    width: auto;
  }
  .knowledge-content.creation-page > .page-heading .heading-actions .button {
    flex: none;
  }
}
.graph-handoff {
  margin: 12px 0 16px;
  padding: 12px 0;
  border-block: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.7;
}

.graph-handoff summary {
  cursor: pointer;
  color: var(--ui-text);
  font-weight: 600;
  min-height: 32px;
}

.graph-handoff p {
  max-width: 75ch;
  margin: 10px 0;
}

.graph-handoff > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

@media (max-width: 640px) {
  .graph-handoff summary {
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}
/* Connected document register and evidence workbench; colors inherit the shared sage system. */
.knowledge-content {
  font-size: 14px;
}
.knowledge-content .page-heading {
  margin-bottom: 20px;
}
.knowledge-content .page-heading h1 {
  font-size: 26px;
  line-height: 1.3;
  letter-spacing: -0.025em;
}
.knowledge-content .register, .knowledge-content .creation, .knowledge-content .candidate-workspace {
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  background: var(--ui-paper);
  box-shadow: none;
}
.knowledge-content .register-toolbar {
  padding: 16px 20px;
  background: var(--ui-navy);
  color: var(--ui-on-navy);
  border-bottom: 0;
}
.knowledge-content .register-toolbar h2 {
  color: var(--ui-on-navy);
}
.knowledge-content .register-toolbar :is(h2 span, .muted) {
  color: color-mix(in srgb, var(--ui-on-navy) 80%, var(--ui-navy));
}
.knowledge-content .register-toolbar > .text-button {
  color: var(--ui-on-navy);
}
.knowledge-content .register-toolbar > .text-button:focus-visible {
  outline-color: #c7d7ff;
}
.knowledge-content .register-toolbar .register-search i {
  color: var(--ui-muted);
}
.knowledge-content .register-toolbar h2 {
  font-size: 16px;
  letter-spacing: -0.015em;
}
.knowledge-content .register-toolbar h2 span {
  font-size: 13px;
  color: color-mix(in srgb, var(--ui-on-navy) 80%, var(--ui-navy));
  font-weight: 500;
}
.knowledge-content .register-toolbar p {
  font-size: 12px;
}
.knowledge-content .register-search {
  max-width: 320px;
}
.knowledge-content input, .knowledge-content select, .knowledge-content textarea {
  border-radius: 9px;
  border-color: var(--ui-control);
  background: var(--ui-paper);
}
.knowledge-content .register-search input {
  border: 1px solid var(--ui-control);
}
.knowledge-content .document-jobs {
  margin: 0;
  border-bottom: 1px solid var(--ui-line);
}
.knowledge-content .document-jobs > summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 66px;
  padding: 16px 20px;
  list-style: none;
  background: var(--ui-paper);
}
.knowledge-content .document-jobs > summary::-webkit-details-marker {
  display: none;
}
.knowledge-content .document-jobs > summary::before {
  content: "";
  width: 7px;
  height: 7px;
  flex: none;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(-45deg);
  color: var(--ui-muted);
}
.knowledge-content .document-jobs[open] > summary::before {
  transform: rotate(45deg);
}
.knowledge-content .document-jobs[open] > summary {
  background: var(--ui-soft);
}
.knowledge-content .document-jobs > summary:hover {
  background: var(--ui-selected);
}
.knowledge-content .document-title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: var(--ui-ink);
}
.knowledge-content .document-count {
  margin: 0;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--ui-muted);
}
.knowledge-content .job-queue-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  padding: 8px 18px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}
.knowledge-content .job-queue-tabs > span {
  margin-right: 8px;
  color: var(--ui-muted);
  font-size: 12px;
}
.knowledge-content .job-queue-tabs button {
  min-height: 36px;
  padding: 7px 12px;
  border-radius: 7px;
  font-size: 13px;
  color: var(--ui-text);
}
.knowledge-content .job-queue-tabs button.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  font-weight: 600;
}
.knowledge-content .job-queue-tabs button:hover:not(.active) {
  background: var(--ui-selected);
}
.knowledge-content .concept-info {
  margin: 0 18px 12px;
  border-bottom: 1px solid var(--ui-line);
}
.knowledge-content .concept-info > summary {
  padding: 8px 0;
  cursor: pointer;
  color: var(--ui-text);
  font-size: 13px;
}
.knowledge-content .candidate-decision {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 18px;
  background: var(--ui-soft);
  border-block: 1px solid var(--ui-line);
}
.knowledge-content .candidate-decision > span {
  font-size: 12px;
  color: var(--ui-muted);
  max-width: 42ch;
}
.knowledge-content .candidate-decision > .button {
  flex: none;
}
.knowledge-content .document-job-heading {
  background: var(--ui-soft);
  padding-block: 10px;
  font-size: 12px;
}
.knowledge-content .document-job {
  min-height: 58px;
  padding-block: 12px;
  border-color: var(--ui-line);
  background: var(--ui-paper);
}
.knowledge-content .document-job:hover {
  background: var(--ui-selected);
}
.knowledge-content .document-job.last-job {
  background: var(--ui-selected);
}
.knowledge-content .job-review-counts {
  font-size: 12px;
  line-height: 1.65;
}
.knowledge-content .state {
  border: 0;
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 600;
}
.knowledge-content .state[data-state=COMPLETED] {
  background: var(--ui-success-soft);
  color: var(--ui-success);
}
.knowledge-content .state[data-state=FAILED], .knowledge-content .state[data-state=NEEDS_ATTENTION] {
  background: #fff4e3;
  color: var(--ui-warning);
}
.knowledge-content .register > .pagination {
  background: var(--ui-soft);
  padding: 12px 18px;
}
.knowledge-content .job-context {
  padding: 0;
  margin: 0 0 10px;
  background: transparent;
  color: var(--ui-text);
  font-size: 14px;
}
.knowledge-content .job-status-details {
  margin-bottom: 16px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  padding: 12px 16px;
}
.knowledge-content .job-status-details .run-summary {
  padding: 0;
  margin: 0;
  background: transparent;
}
.knowledge-content .job-status-details .review-summary {
  margin: 6px 0 0;
  padding: 0;
}
.knowledge-content .candidate-workspace {
  gap: 0;
  overflow: hidden;
}
.knowledge-content .candidate-list {
  background: var(--ui-soft);
  border-right: 1px solid var(--ui-line);
}
.knowledge-content .work-navigation {
  margin: 12px 12px 2px;
  padding: 3px;
  gap: 3px;
  border: 1px solid var(--ui-control);
  border-radius: 9px;
  background: var(--ui-paper);
}
.knowledge-content .work-navigation button {
  border: 0;
  min-height: 34px;
  border-radius: 7px;
  padding: 6px;
  font-size: 13px;
  font-weight: 550;
  color: var(--ui-text);
}
.knowledge-content .work-navigation button.active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  font-weight: 650;
  box-shadow: none;
}
.knowledge-content .search-toolbar {
  padding: 10px 12px;
}
.knowledge-content .filter-panel {
  background: var(--ui-soft);
}
.knowledge-content .candidate-table {
  padding: 0;
  background: var(--ui-soft);
}
.knowledge-content .candidate-row {
  margin: 0;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  padding: 14px 12px;
}
.knowledge-content .candidate-row:hover {
  background: var(--ui-selected);
}
.knowledge-content .candidate-row.selected {
  background: var(--ui-selected);
  box-shadow: none;
}
.knowledge-content .candidate-row.selected strong {
  color: var(--ui-accent);
}
.knowledge-content .candidate-row-top strong {
  font-size: 15px;
  font-weight: 600;
}
.knowledge-content .candidate-meta, .knowledge-content .candidate-source {
  font-size: 12px;
  line-height: 1.6;
}
.knowledge-content .candidate-list > .pagination {
  padding: 10px;
  background: var(--ui-soft);
}
.knowledge-content .inspector {
  background: var(--ui-paper);
  padding-bottom: 20px;
}
.knowledge-content .inspector-navigation {
  padding: 8px 18px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}
.knowledge-content .inspector .inspector-heading {
  padding: 20px 24px 16px;
}
.knowledge-content .inspector .inspector-heading h2 {
  font-size: 24px;
  line-height: 1.45;
  font-weight: 650;
}
.knowledge-content .inspector > :is(p, dl, .evidence-label, .review-form, .evidence) {
  margin-inline: 24px;
}
.knowledge-content .inspector .concept-meta {
  padding: 9px 12px;
  background: var(--ui-soft);
  border: 0;
  border-radius: 8px;
}
.knowledge-content .inspector .evidence h4 {
  font-size: 14px;
}
.knowledge-content .inspector .evidence blockquote {
  font-size: 17px;
  line-height: 1.85;
  background: var(--ui-soft);
  border: 0;
  border-radius: 8px;
  padding: 18px 20px;
}
.knowledge-content .inspector .review-form {
  padding: 12px 16px;
  border-radius: 10px;
  background: var(--ui-soft);
}
.knowledge-content .review-welcome {
  background: var(--ui-paper);
  min-height: 380px;
}
.knowledge-content .review-welcome > i {
  display: block;
  color: var(--ui-accent);
  font-size: 28px;
  margin-bottom: 18px;
}
.knowledge-content .review-welcome h2 {
  font-size: 18px;
}
.knowledge-content .creation {
  overflow: visible;
}
.knowledge-content .creation-main {
  padding: 26px;
  background: var(--ui-paper);
  border-radius: 14px 14px 0 0;
}
.knowledge-content .creation .section-heading {
  margin-top: 20px;
}
.knowledge-content .creation .section-heading h2, .knowledge-content .creation .step-heading h2 {
  font-size: 17px;
}
.knowledge-content .job-name {
  max-width: 680px;
}
.knowledge-content .source-empty {
  background: var(--ui-soft);
  border-radius: 10px;
}
.knowledge-content .source-empty > i {
  color: var(--ui-accent);
}
.knowledge-content .selected-sources li {
  padding: 14px 0;
}
.knowledge-content .creation-summary {
  margin-top: 0;
  border-top: 1px solid var(--ui-line);
  padding: 18px 26px;
  background: var(--ui-soft);
  border-radius: 0 0 14px 14px;
}
.knowledge-content .creation-footer {
  margin-top: 8px;
}
.knowledge-content .creation-footer .button {
  border-radius: 9px;
}
.knowledge-content .graph-handoff {
  margin: 14px 0 18px;
  padding: 10px 14px;
  border: 0;
  border-radius: 10px;
  background: var(--ui-soft);
  color: var(--ui-text);
}
.knowledge-content .graph-handoff summary {
  color: var(--ui-text);
}
.knowledge-content .message, .knowledge-content .error-details {
  border-radius: 10px;
}
.knowledge-content .button {
  border-radius: 9px;
}
.knowledge-content .text-button {
  border-radius: 7px;
}
.knowledge-content .button.secondary {
  border-color: var(--ui-control);
}

.source-picker {
  border: 0;
  border-radius: 16px;
  box-shadow: var(--ui-overlay-shadow, 0 18px 64px rgba(35, 39, 47, 0.16));
}

.source-picker::backdrop {
  background: rgba(35, 39, 47, 0.35);
}

.source-picker .picker-header, .source-picker .picker-footer {
  background: var(--ui-soft);
}

.source-picker .picker-selection {
  background: var(--ui-soft);
}

.source-picker .picker-search input {
  border-radius: 9px;
}

@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .knowledge-content :is(.document-jobs > summary, .document-job, .candidate-row, .work-navigation button) {
    transition: background-color var(--ui-duration, 180ms) var(--ui-ease, ease-out), color var(--ui-duration, 180ms) var(--ui-ease, ease-out), box-shadow var(--ui-duration, 180ms) var(--ui-ease, ease-out);
  }
  .knowledge-content .document-jobs > summary::before {
    transition: transform var(--ui-duration, 180ms) var(--ui-ease, ease-out);
  }
}
@media (max-width: 1100px) {
  .knowledge-content:has(.has-inspector) .job-status-details {
    padding: 4px 12px;
  }
}
@media (max-width: 800px) {
  .knowledge-content .register-toolbar {
    padding: 14px;
  }
  .knowledge-content .document-jobs > summary {
    padding: 14px;
    gap: 10px;
    flex-wrap: wrap;
  }
  .knowledge-content .document-title {
    flex-basis: calc(100% - 24px);
  }
  .knowledge-content .document-count {
    margin-left: 18px;
  }
  .knowledge-content .document-job {
    padding: 12px 14px;
  }
  .knowledge-content .job-queue-tabs {
    padding: 8px 12px;
  }
  .knowledge-content .job-queue-tabs button {
    min-height: 44px;
  }
  .knowledge-content .candidate-decision {
    padding: 12px;
  }
  .knowledge-content .candidate-decision > .button {
    min-height: 44px;
  }
  .knowledge-content .concept-info {
    margin-inline: 12px;
  }
  .knowledge-content .candidate-row {
    padding: 13px 10px;
  }
  .knowledge-content .inspector .inspector-heading {
    padding: 14px 16px;
  }
  .knowledge-content .inspector > :is(p, dl, .evidence-label, .review-form, .evidence) {
    margin-inline: 16px;
  }
  .knowledge-content .creation-main {
    padding: 18px;
  }
  .knowledge-content .creation-summary {
    padding: 16px 18px;
  }
  .knowledge-content .job-status-details {
    padding: 10px 12px;
  }
}
@media (max-width: 600px) {
  .knowledge-content .page-heading h1 {
    font-size: 24px;
  }
  .knowledge-content .page-heading {
    margin-bottom: 16px;
  }
  .knowledge-content :is(input:not([type=checkbox]), select, textarea) {
    font-size: 16px;
    min-height: 44px;
  }
  .knowledge-content input[type=checkbox] {
    appearance: auto;
    width: 18px;
    height: 18px;
    min-height: 18px;
    padding: 0;
  }
  .knowledge-content .work-navigation button {
    min-height: 44px;
  }
  .knowledge-content .register-toolbar {
    gap: 10px;
  }
  .knowledge-content .document-job {
    font-size: 13px;
  }
  .knowledge-content .inspector .inspector-heading h2 {
    font-size: 21px;
  }
  .knowledge-content .inspector .evidence blockquote {
    padding: 14px;
    font-size: 16px;
  }
  .knowledge-content .review-welcome {
    min-height: 260px;
  }
}
@media (pointer: coarse) {
  .knowledge-content .work-navigation button {
    min-height: 44px;
  }
  .knowledge-content :is(input:not([type=checkbox]), select, textarea) {
    min-height: 44px;
  }
}
/* Task provenance belongs with execution details; candidate findings lead into evidence. */
.job-status-details .job-context {
  margin: 0;
  padding: 12px 18px;
  border-bottom: 1px solid var(--ui-line);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.inspector .candidate-issues {
  padding: 14px 16px;
  margin-block: 16px;
}

.candidate-issues-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.6;
}

.candidate-issues > p {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.75;
  overflow-wrap: anywhere;
}

.candidate-issues details {
  margin-top: 8px;
}

.candidate-issues details > summary {
  min-height: 36px;
  padding: 6px 0;
  font-size: 13px;
  line-height: 1.6;
  cursor: pointer;
}

.candidate-issues ul {
  display: grid;
  gap: 8px;
  margin: 6px 0 0;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.75;
}

.candidate-issues li {
  overflow-wrap: anywhere;
}

@media (max-width: 760px) {
  .job-status-details .job-context {
    padding: 12px;
  }
  .candidate-issues details > summary {
    min-height: 44px;
  }
}
@media (pointer: coarse) {
  .candidate-issues details > summary {
    min-height: 44px;
  }
}
/* Task information remains reachable with or without a selected candidate. */
.knowledge-content .job-status-details > summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  min-height: 44px;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.6;
  cursor: pointer;
  list-style: none;
}

.knowledge-content .job-status-details > summary::-webkit-details-marker {
  display: none;
}

.knowledge-content .job-status-details > summary > span {
  margin-left: auto;
  color: var(--ui-muted);
  font-size: 12px;
}

.knowledge-content .job-status-details > summary > i {
  font-size: 11px;
  color: var(--ui-muted);
}

.knowledge-content .job-status-details[open] > summary > i {
  transform: rotate(180deg);
}

/* Keep review, exploration and execution inside one knowledge workspace. */
.knowledge-sections {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin: 0 0 20px;
  padding: 4px;
  border: 1px solid var(--ui-line);
  border-radius: 10px;
  background: var(--ui-soft);
}

.knowledge-sections > a, .knowledge-sections > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 9px 16px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ui-text);
  font: inherit;
  font-size: 14px;
  font-weight: 550;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.knowledge-sections > .active {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  font-weight: 650;
}

.knowledge-sections > :hover:not(.active):not(:disabled) {
  background: var(--ui-selected);
}

.knowledge-sections > :focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
}

.knowledge-sections > :disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 600px) {
  .knowledge-sections {
    gap: 3px;
    margin-bottom: 16px;
  }
  .knowledge-sections > a, .knowledge-sections > button {
    flex: 1;
    min-height: 44px;
    padding: 8px 10px;
    font-size: 13px;
  }
}
.knowledge-content.jobs-view .document-job-heading, .knowledge-content.jobs-view .document-job {
  grid-template-columns: minmax(0, 1fr) 140px 120px 180px 110px;
}

@media (max-width: 800px) {
  .knowledge-content.jobs-view .document-job {
    grid-template-columns: minmax(0, 1fr) auto;
  }
}`],
})
export class PageKnowledge_graphComponent implements OnInit, OnDestroy {
    openRow(event:MouseEvent) { activateListRow(event); }
    @ViewChild('sourcePicker') sourcePicker!:ElementRef<HTMLDialogElement>;
    pickerOpen=false; pickerLoading=false; pickerSaving=false; pickerError='';
    pickerPath='storage'; pickerQuery=''; pickerSelected:any[]=[];
    pickerData:any={items:[],page:1,pages:1,total:0}; private pickerEpoch=0;
    private bodyOverflow:string|null=null;
    workspacePage='지식 관리'; workspaceView='review'; user:any; csrf=''; loading=true; busy=false; error=''; bootstrapError=''; sessionReady=false; private bootstrapping=false; editing=false; dirty=false;
    data:any={items:[],page:1,pages:1,total:0,ready:false}; detail:any=null; plan:any=null;
    draft:any={type:'QA',name:'',target:100,selection:[],excluded:[],ranges:{}};
    results:any={items:[],page:1,pages:1,total:0}; selected:any=null;
    mode='review'; reviewDraft:any={}; reviewDirty=false; reviewError=''; saved=''; graphLoading=false; graphScope='ai'; graphQuery=''; graphNode=''; graphData:any={nodes:[],edges:[],items:[],terms:[]}; graphFocus:any=null; graphNeighbors:any[]=[];
    filtersOpen=false; private returnFocus:any=null;
    kind='concept'; type=''; check=''; reviewState=''; query=''; source=''; resultLoading=false; itemLoading=false; navigatingCandidate=false; resultsLoaded=false;
    private appliedResults:any={kind:'concept',type:'',check:'',review_state:'',q:'',source:''};
    detailId=''; detailError=''; resultsError=''; detailRefreshing=false; private retryCount=0; private detailRequest=0;
    focusCandidate=0; jobQuery=''; jobScope='all'; listPage=1; lastJob=''; private restoreListFocus=false; openGroups=new Set<string>(); private groupsInitialized=false;
    idempotency=''; private epoch=0; private graphEpoch=0; private resultEpoch=0; private itemEpoch=0; private timer:any; private sub:any; private alive=true;
    readonly conceptTypes:any={"CONDITION":"질환·병증 · 이전 추출","SYMPTOM":"증상 · 이전 추출","FORMULA":"처방 · 이전 추출","HERB":"본초 · 이전 추출","ACUPOINT":"경혈 · 이전 추출","MERIDIAN_REF":"경락 참조 · 이전 추출","Herb":"본초","Formula / Protocol":"처방·복합 요법","Acupoint":"경혈·경락","TKM_Concept / Theory":"한의 개념·이론","Compound":"화합물","Gene / Variant":"유전자·변이","Pathway":"생물학적 경로","Biomarker":"생체 지표","Cell Type & Receptor":"세포·수용체","Biological Process":"생물학적 과정","Disease":"질환","Pattern":"병증·변증","Symptom / Phenotype":"증상·표현형","Constitution":"체질","Severity & Stage":"중증도·단계","Intervention":"치료·중재","Modern_Medication":"현대 의약품","Diagnostic_Device / Alg":"진단 기기·알고리즘","Assessment & Observation":"평가·관찰","Source_Text":"출처 문헌","Historical_Figure":"의가·역사 인물"};
    readonly relationTypes:any={"HAS_SYMPTOM":"증상","INDICATED_FOR":"주치","CONTAINS_HERB":"구성 본초","RELATED_TO":"관련","MERIDIAN":"본초 귀경","CO_ADMINISTERED_WITH":"병용","PAIRED_WITH":"배합","TREATS":"치료","PREVENTS":"예방","SYNERGIZES_WITH":"상승효과","MODULATES":"조절","HAS_OUTCOME":"관찰 결과","UPREGULATES":"상향 조절","ACTIVATES":"활성화","DOWNREGULATES":"하향 조절","INHIBITS":"억제","CAUSES":"원인","INDUCES":"유발","INTERACTS_WITH_NEGATIVELY":"유해 상호작용","CAUSES_ADVERSE_EVENT":"이상 반응 유발","CONTRAINDICATED_IN":"금기","DIAGNOSES":"진단","EXCLUDES":"진단 배제","IS_MANDATORY_FOR":"필수 진단 조건","REQUIRES_ALL":"모든 조건 필요","MEASURES":"측정","HAS_CRITERION":"진단 기준","PATTERN_OF":"질환의 변증","COMORBID_WITH":"동반 질환","HAS_TRAIT":"고유 특성","HAS_INGREDIENT":"구성 성분","USES_ACUPOINT":"사용 경혈","BELONGS_TO_MERIDIAN":"경혈 소속 경락","ASSOCIATED_WITH":"연관","BIOMARKER_OF":"생체 지표 관계","MARKER_OF":"특징 지표","INVOLVES_PROCESS":"연관 과정","SUBTYPE_OF":"하위 유형","CLASSIFIES_INTO":"분류","PROGRESSES_TO":"진행","DESCRIBED_IN":"문헌 수록","ORIGINATES_FROM":"기원"};
    private initialSession:any=null;
    constructor(@Inject(Service) public service:Service,@Inject(ActivatedRoute) private route:ActivatedRoute,@Inject(Router) private router:Router) {
        const session=this.route.snapshot?.data?.['workspace']?.session;
        if(session?.code===200 && session.data?.user) {
            this.initialSession=session;this.user=session.data.user;this.csrf=session.data.csrf;
        }
    }
    get canWrite() { return this.user?.status==='active' && ['admin','researcher'].includes(this.user?.role); }
    async ngOnInit() {
        await this.service.init(); document.title='지식 관리 · 한의문헌 저작도구';
        await this.bootstrap();
    }
    async bootstrap() {
        if(!this.alive || this.bootstrapping) return;
        this.bootstrapping=true; this.loading=true; this.bootstrapError=''; await this.service.render();
        try {
            const boot=this.initialSession || await wiz.app('page.access').call('bootstrap',{});
            this.initialSession=null;
            if(!this.alive) return;
            if(boot.code===401 || (boot.code===200 && !boot.data?.user)) { this.service.href('/access/login'); return; }
            if(boot.code!==200) throw new Error('bootstrap');
            this.user=boot.data.user; this.csrf=boot.data.csrf; this.sessionReady=true;
        } catch {
            if(this.alive) { this.sessionReady=false; this.bootstrapError='계정 정보를 불러오지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.'; }
        } finally { this.bootstrapping=false; }
        if(!this.alive) return;
        // Keep one loading state until the route's first list/detail response arrives.
        if(this.sessionReady) this.subscribeRoute();
        else this.loading=false;
        await this.service.render();
    }
    private subscribeRoute() {
        if(this.sub || !this.alive) return;
        this.sub=this.route.queryParamMap.subscribe(params=>{
            this.restoreListFocus=!!this.detailId && !params.get('id');
            clearTimeout(this.timer); this.detailRequest++; this.detailId=params.get('id') || ''; this.detailError=''; this.resultsError=''; this.retryCount=0; this.detailRefreshing=false;
            this.focusCandidate=Math.max(0,Number(params.get('candidate')) || 0);
            this.listPage=Math.max(1,Number(params.get('page')) || 1);
            const nextView=params.get('view')==='jobs' ? 'jobs' : 'review';
            if(nextView!==this.workspaceView) this.jobScope='all';
            this.workspaceView=nextView;
            this.epoch++; this.graphEpoch++; this.resultEpoch++; this.itemEpoch++;
            this.detail=null; this.selected=null; this.mode='review'; this.graphScope='ai'; this.graphQuery=''; this.graphNode=''; this.graphData={nodes:[],edges:[],items:[],terms:[]}; this.reviewDirty=false; this.reviewError=''; this.saved=''; this.results={items:[],page:1,pages:1,total:0};
            this.kind='concept'; this.type=''; this.check=''; this.reviewState=''; this.query=''; this.source='';
            this.appliedResults=this.resultFilters();this.resultsLoaded=false;this.navigatingCandidate=false;
            this.resultLoading=false; this.itemLoading=false; this.error='';
            this.filtersOpen=false;this.editing=params.get('new')==='1';
            if(params.get('id') && this.canWrite) this.loadDetail(params.get('id')!,false,this.epoch);
            else if(!this.editing && this.canWrite) this.refresh(this.listPage);
            else this.loading=false;
            this.service.render();
        });
    }
    ngOnDestroy() { this.alive=false; clearTimeout(this.timer); this.epoch++; this.graphEpoch++; this.resultEpoch++; this.itemEpoch++; this.pickerEpoch++; this.sub?.unsubscribe(); this.restorePickerScroll(); }
    @HostListener('window:beforeunload',['$event'])
    beforeUnload(e:BeforeUnloadEvent) { if(this.dirty || this.reviewDirty || this.busy) { e.preventDefault(); e.returnValue=''; } }
    canDeactivate() { return !this.busy && (!(this.dirty || this.reviewDirty) || window.confirm('입력 내용이 저장되지 않았습니다. 나가시겠습니까?')); }
    async call(action:string,values:any={}) {
        try {
            const response=await wiz.app('page.knowledge_graph').call(action,{csrf:this.csrf,...values});
            if(!this.alive)throw new Error('화면을 닫아 요청을 취소했습니다.');
            if(response.code===401) this.service.href('/access/login');
            if(response.code!==200) { const error:any=new Error(response.data?.message || '처리하지 못했습니다. 다시 시도해 주세요.'); error.code=response.code; throw error; }
            return response.data;
        } catch(value:any) {
            const error:any=new Error(value?.message || '요청을 처리하지 못했습니다. 연결을 확인하고 다시 시도해 주세요.');
            error.code=value?.code || value?.status;throw error;
        }
    }
    async refresh(page=1) {
        const epoch=this.epoch; this.loading=true; await this.service.render();
        try { const data=await this.call('list',{page,grouped:1}); if(epoch===this.epoch) { this.data=data; this.listPage=data.page; this.error=''; if(!this.groupsInitialized && data.items.length){this.openGroups.add(data.items[0].key);this.groupsInitialized=true;} } }
        catch(e:any) { if(epoch===this.epoch) {if(this.denied(e)) this.clearKnowledge(); this.error=e.message; await this.service.render();} }
        finally { if(epoch===this.epoch) {this.loading=false; await this.service.render(); if(this.restoreListFocus) {this.restoreListFocus=false; const target=document.getElementById('job-'+this.lastJob); target?.scrollIntoView({block:'nearest'}); target?.focus({preventScroll:true});}} }
    }
    get visibleGroups() {
        const q=this.jobQuery.trim().toLocaleLowerCase();
        return this.data.items.filter((g:any)=>!q || (g.name+' '+(g.documents||[]).join(' ')).toLocaleLowerCase().includes(q)).map((g:any)=>{
            if(this.jobScope==='all')return g;
            const jobs=(g.jobs||[]).filter((j:any)=>this.jobScope==='review' ? Number(j.review_counts?.PENDING||0)>0 : this.jobScope==='complete' ? j.status_code==='COMPLETED' : ['QUEUED','RUNNING','PAUSING','PAUSED','FAILED','NEEDS_ATTENTION'].includes(j.status_code));
            return {...g,jobs,candidates:jobs.reduce((sum:number,j:any)=>sum+Number(j.candidates||0),0)};
        }).filter((g:any)=>this.jobScope==='all'||g.jobs.length);
    }
    setJobScope(value:string) {
        if(!['all','review','processing','complete'].includes(value)||this.loading)return;
        this.jobScope=value;
        if(value!=='all')this.visibleGroups.forEach((g:any)=>this.openGroups.add(g.key));
        this.service.render();
    }
    async openSection(section:string) {
        if(!['review','map','jobs'].includes(section) || !this.canDeactivate())return;
        if(section===this.workspaceView && !this.detailId && !this.editing)return;
        const dirty=this.dirty,reviewDirty=this.reviewDirty;
        this.dirty=false;this.reviewDirty=false;
        try {
            const moved=await this.router.navigate([section==='map' ? '/knowledge-map' : '/knowledge-graph'],
                {queryParams:section==='jobs' ? {view:'jobs'} : {}});
            if(moved===false){this.dirty=dirty;this.reviewDirty=reviewDirty;}
        } catch(error) {this.dirty=dirty;this.reviewDirty=reviewDirty;throw error;}
    }
    get selectedIndex() { return this.results.items.findIndex((i:any)=>i.candidate_id===this.selected?.candidate_id); }
    get candidateWorking() {return this.busy || this.itemLoading || this.navigatingCandidate || this.resultLoading;}
    get candidatePosition() {return this.selectedIndex<0 ? null : (this.results.page-1)*(this.results.page_size || 30)+this.selectedIndex+1;}
    resultFilters() {return {kind:this.kind,type:this.type,check:this.check,review_state:this.reviewState,q:this.query.trim(),source:this.source};}
    get resultFiltered() {return !!(this.appliedResults.type || this.appliedResults.check || this.appliedResults.review_state || this.appliedResults.q || this.appliedResults.source);}
    neighbor(delta:number,items=this.results.items) {
        const id=Number(this.selected?.candidate_id);
        return delta<0 ? [...items].reverse().find((r:any)=>Number(r.candidate_id)<id) : items.find((r:any)=>Number(r.candidate_id)>id);
    }
    canAdjacent(delta:number) {
        if(!this.selected || !this.resultsLoaded || this.mode!=='review' || this.appliedResults.kind!==this.selected.kind)return false;
        return !!this.neighbor(delta) || (delta<0 ? this.results.page>1 : this.results.page<this.results.pages);
    }
    acceptCandidate(result:any) {
        this.selected=result;this.reviewDraft={...result.data,note:result.note || ''};
        this.reviewDirty=false;this.reviewError='';this.saved='';
    }
    async focusCandidateTitle() {
        await this.service.render();document.getElementById('candidate-title')?.focus({preventScroll:true});
        if(window.innerWidth<=1100)document.querySelector('.inspector')?.scrollIntoView({block:'start',behavior:'instant'});
    }
    async adjacentCandidate(delta:number) {
        if(this.candidateWorking || this.resultLoading || !this.canAdjacent(delta) || !this.leaveReview())return;
        const request=++this.itemEpoch,epoch=this.epoch,id=this.detail.job_id,selected=this.selected,draft=JSON.stringify(this.reviewDraft);
        const filters={...this.appliedResults},filterKey=JSON.stringify(filters);
        const current=()=>this.alive && epoch===this.epoch && request===this.itemEpoch && id===this.detail?.job_id && this.selected===selected &&
            draft===JSON.stringify(this.reviewDraft) && filterKey===JSON.stringify(this.appliedResults) && this.mode==='review';
        this.resultEpoch++;this.navigatingCandidate=true;this.error='';await this.service.render();
        try {
            let list=this.results,item=this.neighbor(delta);
            if(!item) {
                list=await this.call('candidates',{id,page:this.results.page+delta,...filters});
                if(!current())return;
                item=this.neighbor(delta,list.items);
            }
            if(!item) {this.error='현재 조건에서 더 이동할 후보가 없습니다. 목록을 다시 확인해 주세요.';return;}
            const result=await this.call('item',{id,candidate_id:item.candidate_id});
            if(!current())return;
            this.results=list;this.resultsError='';this.acceptCandidate(result);await this.focusCandidateTitle();
        } catch(e:any) {if(current()){if(this.denied(e))this.clearKnowledge();this.error=e.message;}}
        finally {if(request===this.itemEpoch){this.navigatingCandidate=false;await this.service.render();}}
    }
    date(value:string) {return formatWorkspaceDate(value);}
    groupDocuments(group:any) {return [...new Set((group.documents || []).filter((name:any)=>typeof name==='string' && name.trim() && name!==group.name))].join(' · ');}
    groupToggle(key:string,event:Event) { if((event.target as HTMLDetailsElement).open) this.openGroups.add(key); else this.openGroups.delete(key); }
    async openJob(job:any,group:any) {
        this.lastJob=job.job_id; this.openGroups.add(group.key);
        await this.router.navigate(['/knowledge-graph'],{queryParams:{id:job.job_id,page:this.data.page,view:this.workspaceView==='jobs' || !Number(job.candidates) ? 'jobs' : null}});
    }
    async listNavigate(page:number) { await this.router.navigate(['/knowledge-graph'],{queryParams:{page,view:this.workspaceView==='jobs' ? 'jobs' : null}}); }
    async newJob() {
        this.draft={type:'QA',name:'',target:100,selection:[],excluded:[],ranges:{}};
        this.plan=null; this.idempotency=''; this.dirty=false;
        await this.router.navigate(['/knowledge-graph'],{queryParams:{new:1,page:this.listPage,view:'jobs'}});
    }
    async back() {
        if(!this.canDeactivate()) return;
        this.dirty=false; this.reviewDirty=false; await this.router.navigate(['/knowledge-graph'],{queryParams:{page:this.listPage,view:this.workspaceView==='jobs' ? 'jobs' : null}});
    }
    change() { this.dirty=true; this.idempotency=''; if(this.plan) this.plan.stale=true; this.service.render(); }
    remove(key:string) { this.draft.selection=this.draft.selection.filter((x:any)=>x.key!==key); this.change(); }
    async prepare() {
        if(this.busy) return; this.busy=true; this.error=''; await this.service.render();
        try { this.plan=await this.call('prepare',{data:JSON.stringify(this.draft)}); }
        catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    async start() {
        if(this.busy || !this.plan?.summary.usable_pages) return;
        this.busy=true; this.error=''; await this.service.render();
        if(!this.idempotency) this.idempotency=crypto.randomUUID().replace(/-/g,'');
        try {
            const result=await this.call('submit',{data:JSON.stringify(this.draft),fingerprint:this.plan.fingerprint,idempotency:this.idempotency});
            this.dirty=false; this.busy=false;
            await this.router.navigate(['/knowledge-graph'],{queryParams:{id:result.job_id,view:'jobs'}});
        } catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    clearKnowledge() {
        this.epoch++; this.detailRequest++; this.data={items:[],page:1,pages:1,total:0,job_total:0,ready:false};
        this.openGroups.clear(); this.groupsInitialized=false; this.lastJob=''; this.restoreListFocus=false;
        this.loading=false; this.detailRefreshing=false; this.detailError=''; this.resultsError='';
        this.detail=null; this.selected=null; this.reviewDraft={}; this.reviewDirty=false;
        this.results={items:[],page:1,pages:1,total:0}; this.resultEpoch++; this.itemEpoch++; this.graphEpoch++;
        this.resultLoading=false; this.itemLoading=false; this.navigatingCandidate=false;this.resultsLoaded=false;this.graphLoading=false;
        this.graphData={nodes:[],edges:[],items:[],terms:[]}; this.graphFocus=null; this.graphNeighbors=[];
        clearTimeout(this.timer);
    }
    denied(error:any) { return [401,403,404].includes(error.code); }
    async retryDetail() { this.retryCount=0; await this.loadDetail(this.detailId,true); }
    async loadDetail(id:string,poll=false,epoch=this.epoch) {
        clearTimeout(this.timer);
        const request=++this.detailRequest;
        this.detailRefreshing=true;
        if(!poll) this.loading=true;
        await this.service.render();
        try {
            const value=await this.call('detail',{id});
            if(epoch!==this.epoch || request!==this.detailRequest) return;
            const changed=JSON.stringify(value.counts)!==JSON.stringify(this.detail?.counts) || JSON.stringify(value.review_counts)!==JSON.stringify(this.detail?.review_counts) || value.changed!==this.detail?.changed;
            this.detail=value; this.detailError=''; this.retryCount=0;
            if(value.unavailable) { this.clearKnowledge(); this.detail=value; await this.service.render(); }
            else if(!poll || changed || this.resultsError) {
                if(!poll && this.focusCandidate) {
                    await this.inspect({candidate_id:this.focusCandidate});
                    if(epoch!==this.epoch || !this.detail) return;
                    if(this.selected) this.kind=this.selected.kind;
                }
                if(!this.navigatingCandidate)await this.loadResults(this.results.page,poll,this.selected?.candidate_id || 0);
                if(!poll && epoch===this.epoch && request===this.detailRequest && this.detail?.job_id===id &&
                   !this.focusCandidate && !this.selected && !this.itemLoading && this.resultsLoaded && !this.resultsError &&
                   window.innerWidth>1100 && this.results.items.length)
                    await this.inspect(this.results.items[0]);
            }
            if(this.detail && !value.unavailable && ['QUEUED','RUNNING','PAUSING','CANCELLING'].includes(value.status_code))
                this.timer=setTimeout(()=>this.loadDetail(id,true,epoch),4000);
        } catch(e:any) {
            if(epoch!==this.epoch || request!==this.detailRequest) return;
            if(this.denied(e)) { this.clearKnowledge(); this.error=e.message; this.detailError=''; await this.service.render(); }
            else {
                this.detailError=this.detail ? '최신 상태를 가져오지 못했습니다. 기존 화면과 작성 중인 내용은 유지됩니다.' : '작업을 불러오지 못했습니다.';
                if(this.retryCount<3) { const delay=4000*Math.pow(2,this.retryCount++); this.timer=setTimeout(()=>this.loadDetail(id,true,epoch),delay); }
            }
        } finally { if(epoch===this.epoch && request===this.detailRequest) {this.loading=false; this.detailRefreshing=false; await this.service.render();} }
    }
    async command(action:string) {
        if(this.busy || !this.detail) return;
        this.busy=true; this.error=''; clearTimeout(this.timer); await this.service.render();
        try { await this.call(action,{id:this.detail.job_id}); await this.loadDetail(this.detail.job_id,true); }
        catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    async loadResults(page=1,applied=false,locate=0,closeSelection=false) {
        if(!this.detail || this.detail.unavailable || (this.navigatingCandidate && !closeSelection))return false;
        const epoch=++this.resultEpoch,id=this.detail.job_id,filters=applied?{...this.appliedResults}:this.resultFilters();
        const selected=this.selected,draft=JSON.stringify(this.reviewDraft);
        if(closeSelection){this.itemEpoch++;this.itemLoading=false;this.navigatingCandidate=false;}
        const current=()=>this.alive && epoch===this.resultEpoch && id===this.detail?.job_id;
        this.resultLoading=true;await this.service.render();
        try {
            const result=await this.call('candidates',{id,page,...filters,...(locate>0?{locate}:{})});
            if(!current() || (closeSelection && (this.selected!==selected || JSON.stringify(this.reviewDraft)!==draft)))return false;
            this.results=result;this.appliedResults=filters;this.resultsLoaded=true;this.resultsError='';
            if(closeSelection){this.selected=null;this.reviewDirty=false;this.itemLoading=false;}
            return true;
        } catch(e:any) {
            if(current()){if(this.denied(e)){this.clearKnowledge();this.error=e.message;}else this.resultsError='후보 목록을 갱신하지 못했습니다. 이전 조회 결과를 표시합니다.';}
            return false;
        } finally {if(epoch===this.resultEpoch){this.resultLoading=false;await this.service.render();}}
    }
    async filter() {
        if(!this.leaveReview())return;
        await this.loadResults(1,false,0,true);
    }
    async pageResults(page:number) {
        if(this.candidateWorking || this.resultLoading || !this.leaveReview())return;
        await this.loadResults(page,true,0,true);
    }
    tab(kind:string) {this.setSection(kind);}
    async inspect(item:any,event?:Event) {
        if(this.navigatingCandidate || !this.detail || !this.leaveReview())return;
        const epoch=++this.itemEpoch,id=this.detail.job_id,selected=this.selected,draft=JSON.stringify(this.reviewDraft);
        const current=()=>this.alive && epoch===this.itemEpoch && id===this.detail?.job_id && this.selected===selected && draft===JSON.stringify(this.reviewDraft);
        this.itemLoading=true;this.error='';await this.service.render();
        try {
            const result=await this.call('item',{id,candidate_id:item.candidate_id});
            if(current()){this.returnFocus=event?.currentTarget;this.acceptCandidate(result);await this.focusCandidateTitle();}
        } catch(e:any) {if(current()){if(this.denied(e))this.clearKnowledge();this.error=e.message;}}
        finally {if(epoch===this.itemEpoch){this.itemLoading=false;await this.service.render();}}
    }
    closeItem() {
        if(!this.leaveReview())return;
        const candidateId=this.selected?.candidate_id;
        this.itemEpoch++;this.selected=null;this.reviewDirty=false;this.itemLoading=false;this.navigatingCandidate=false;this.service.render();
        setTimeout(()=>{const target=this.returnFocus?.isConnected ? this.returnFocus : document.querySelector('[data-candidate="'+candidateId+'"]');target?.focus?.();},0);
    }
    get compactCandidateSummary(){return window.innerWidth<=1100;}
    private lastSummaryCompact:boolean|undefined;
    @HostListener('window:resize')
    candidateViewportChanged() {
        const compact=this.compactCandidateSummary;
        if(compact===this.lastSummaryCompact)return;
        this.lastSummaryCompact=compact;this.service.render();
    }
    get activeFilters(){return [this.type,this.check,this.reviewState,this.source].filter(Boolean).length;}
    toggleFilters(){this.filtersOpen=!this.filtersOpen;this.service.render();}
    async applyFilter(key:string,value:string) {
        if(!this.leaveReview()){this.service.render();return;}
        if(key==='type')this.type=value;if(key==='check')this.check=value;if(key==='source')this.source=value;if(key==='review_state')this.reviewState=value;
        await this.loadResults(1,false,0,true);
    }
    async resetFilters() {
        if(!this.leaveReview())return;
        this.type='';this.check='';this.reviewState='';this.source='';this.query='';
        await this.loadResults(1,false,0,true);
    }
    async setSection(section:string){
        if(!this.leaveReview())return;
        this.itemEpoch++;this.resultEpoch++;this.graphEpoch++;this.selected=null;this.reviewDirty=false;this.itemLoading=false;this.navigatingCandidate=false;this.resultLoading=false;this.graphLoading=false;
        this.mode=section==='graph'?'graph':'review';
        if(this.mode==='graph')await this.loadGraph();
        else {this.kind=section;this.type='';await this.loadResults();}
        await this.service.render();
    }
    shortReviewStatus(code:string){return code==='AI_REVIEWED'?'AI 검수':this.reviewStatus(code);}
    labels() { return Object.entries(this.kind==='concept'?this.conceptTypes:this.relationTypes).map(([key,label])=>({key,label})); }
    typeName(code:string) { return this.conceptTypes[code] || this.relationTypes[code] || code; }
    status(code:string) { return ({QUEUED:'대기 중',RUNNING:'후보 추출 중',PAUSING:'일시정지 중',PAUSED:'일시정지',CANCELLING:'취소 중',CANCELLED:'취소됨',COMPLETED:'추출 완료',NEEDS_ATTENTION:'일부 오류',FAILED:'실행 중단'} as any)[code] || code; }
    count(kind:string) { return (this.detail?.stats || []).filter((x:any)=>x.kind===kind).reduce((n:number,x:any)=>n+x.n,0); }
    basename(key:string) { return key?.split('/').pop() || ''; }
    evidenceTarget(e:any) {return this.selected?.evidence_targets?.[e.content_unit_id];}
    evidencePdf(e:any) {const target=this.evidenceTarget(e);return '/wiz/api/page.sources/pdf?path='+encodeURIComponent(target?.path || e.path)+'&page='+encodeURIComponent(target?.page || e.page);}
    evidenceParams(e:any) {const target=this.evidenceTarget(e),path=target?.path || e.path;return {path:path.split('/').slice(0,-1).join('/'),result:path,pdf_page:target?.page || e.page,job:target?.job};}

    reviewStatus(code:string) { return ({PENDING:'검수 대기',AI_REVIEWED:'AI 검수 완료 · 전문가 미승인',APPROVED:'전문가 승인',REJECTED:'반려',DELETED:'삭제'} as any)[code] || code; }
    leaveReview() {
        if(this.busy) return false;
        if(this.reviewDirty && !window.confirm('저장하지 않은 검수 내용이 있습니다. 이동하시겠습니까?')) return false;
        return true;
    }
    async reviewSave(status:string) {
        if(this.candidateWorking || !this.selected) return;
        if(status==='DELETED' && !window.confirm('이 후보를 삭제 처리하고 그래프에서 제외하시겠습니까? 검수 이력은 보존됩니다.')) return;
        const id=this.detail.job_id,epoch=this.epoch,selected=this.selected;
        this.itemEpoch++;this.busy=true; this.error=''; this.reviewError=''; this.saved=''; await this.service.render();
        try {
            const result=await this.call('review',{id:this.detail.job_id,candidate_id:this.selected.candidate_id,
                data:JSON.stringify({...this.reviewDraft,status,revision:this.selected.revision})});
            if(!this.alive || epoch!==this.epoch || id!==this.detail?.job_id || this.selected!==selected)return;
            this.acceptCandidate(result);
            this.saved=result.sync_message || (status==='APPROVED' ? '승인한 지식을 그래프에 반영했습니다.' : '검수 내용을 저장했습니다.');
            await this.loadResults(this.results.page,true,result.candidate_id);
            await this.loadDetail(id,true);
            if(this.mode==='graph') await this.loadGraph(this.graphNode);
        } catch(e:any) {if(this.alive && epoch===this.epoch && id===this.detail?.job_id)this.reviewError=e.message;}
        finally { this.busy=false; await this.service.render(); }
    }
    async setMode(mode:string) {
        if(!this.leaveReview()) return;
        this.mode=mode; this.selected=null;this.reviewDirty=false;this.navigatingCandidate=false;this.itemLoading=false;this.resultLoading=false;this.resultEpoch++;this.itemEpoch++;
        if(mode==='graph') await this.loadGraph(); else await this.loadResults();
        await this.service.render();
    }
    async changeGraphScope(scope:string) {
        if(!this.leaveReview()) { await this.service.render(); return; }
        this.graphScope=scope; this.selected=null;this.reviewDirty=false;this.navigatingCandidate=false;this.itemLoading=false;this.resultLoading=false;this.resultEpoch++;this.itemEpoch++;
        this.graphData={nodes:[],edges:[],items:[],terms:[]}; this.graphFocus=null; this.graphNeighbors=[];
        await this.loadGraph();
    }
    async loadGraph(node='') {
        const id=this.detail?.job_id,epoch=this.epoch,request=++this.graphEpoch;
        if(!id) return;
        this.graphLoading=true; this.graphNode=node; this.error=''; await this.service.render();
        try {
            const value=await this.call('graph',{id,q:this.graphQuery,node,scope:this.graphScope});
            if(id!==this.detail?.job_id || epoch!==this.epoch || request!==this.graphEpoch) return;
            this.graphData={...value,queried_at:new Date().toISOString()};
            this.graphFocus=value.nodes.find((n:any)=>n.id===node) || [...value.nodes].sort((a:any,b:any)=>
                value.edges.filter((e:any)=>e.source===b.id || e.target===b.id).length-value.edges.filter((e:any)=>e.source===a.id || e.target===a.id).length)[0] || null;
            const focus=this.graphFocus?.id;
            this.graphNeighbors=value.nodes.filter((n:any)=>n.id!==focus && value.edges.some((e:any)=>
                (e.source===focus && e.target===n.id) || (e.target===focus && e.source===n.id))).slice(0,12).map((n:any,index:number)=>{
                    const edge=value.edges.find((e:any)=>(e.source===focus && e.target===n.id)||(e.target===focus && e.source===n.id));
                    return {...n,y:50+index*76,edge,incoming:edge.target===focus};
                });
        } catch(e:any) { if(request===this.graphEpoch) {if(this.denied(e)) this.clearKnowledge(); this.error=e.message; await this.service.render();} }
        finally { if(epoch===this.epoch && request===this.graphEpoch) {this.graphLoading=false; await this.service.render();} }
    }
    graphSnapshot() {
        if(this.graphLoading || this.error || !this.graphData.items?.length || !this.graphData.schema_version) return null;
        return {...this.graphData,training_allowed:false,export_scope:'current_query',
            usage:'문헌 근거·검수 상태 비교용 조회 스냅샷. 임베딩·RAG 실행 및 학습 허용은 별도입니다.'};
    }
    downloadGraphSnapshot() {
        const snapshot=this.graphSnapshot(); if(!snapshot)return;
        const url=URL.createObjectURL(new Blob([JSON.stringify(snapshot,null,2)+'\n'],{type:'application/json;charset=utf-8'}));
        const link=document.createElement('a');link.href=url;link.download='knowledge-'+this.detail.job_id+'-'+snapshot.scope+'.json';link.click();
        setTimeout(()=>URL.revokeObjectURL(url),1000);
    }
    get graphHeight() { return Math.max(220,this.graphNeighbors.length*76+24); }
    async syncGraph() {
        if(this.busy) return; this.busy=true; this.error=''; await this.service.render();
        try { const r=await this.call('sync',{id:this.detail.job_id}); if(r.message) this.error=r.message; else await this.loadGraph(this.graphNode); }
        catch(e:any) {this.error=e.message;}
        finally {this.busy=false; await this.service.render();}
    }

    confirmPicker() {
        this.draft.selection=[...this.draft.selection,...this.pickerSelected.map(x=>({key:x.key,kind:x.kind}))];
        this.change(); this.closePicker();
    }
    async addSources() {
        if(this.busy || this.pickerOpen) return;
        this.pickerSelected=[]; this.pickerError=''; this.pickerOpen=true;
        this.pickerPath='storage'; this.pickerQuery='';
        this.bodyOverflow=document.body.style.overflow; document.body.style.overflow='hidden';
        this.sourcePicker.nativeElement.showModal();
        await this.browsePicker('storage');
    }
    restorePickerScroll() {
        if(this.bodyOverflow!==null) { document.body.style.overflow=this.bodyOverflow; this.bodyOverflow=null; }
    }
    closePicker(event?:Event) {
        if(this.pickerSaving) { event?.preventDefault(); return; }
        this.pickerEpoch++; this.pickerOpen=false; this.pickerLoading=false;
        this.sourcePicker.nativeElement.close(); this.restorePickerScroll();
        this.service.render();
    }
    async browsePicker(path:string, page=1, search=false) {
        if(this.pickerSaving) return;
        const epoch=++this.pickerEpoch;
        if(path!==this.pickerPath || !search) this.pickerQuery='';
        this.pickerPath=path; this.pickerLoading=true; this.pickerError='';
        this.pickerData={items:[],page:1,pages:1,total:0};
        await this.service.render();
        try {
            const res=await wiz.app('page.sources').call('browse',{path,q:this.pickerQuery,page});
            if(epoch!==this.pickerEpoch || !this.pickerOpen) return;
            if(res.code!==200) throw new Error(res.data?.message || '자료를 불러오지 못했습니다.');
            this.pickerData=res.data;
        } catch(e:any) { if(epoch===this.pickerEpoch) this.pickerError=e.message || '자료를 불러오지 못했습니다. 다시 시도해 주세요.'; }
        finally { if(epoch===this.pickerEpoch) { this.pickerLoading=false; await this.service.render(); } }
    }
    pickerCrumbs() {
        const parts=this.pickerPath.split('/');
        return parts.map((name,index)=>({name:index===0?'보관함':name,key:parts.slice(0,index+1).join('/')}));
    }
    alreadyAdded(item:any) {
        return this.draft.selection.some((x:any)=>x.key===item.key || (x.kind==='folder' && item.key.startsWith(x.key+'/')));
    }
    picked(item:any) { return this.pickerSelected.some(x=>x.key===item.key); }
    pickerEligible(item:any) { return !['blocked','missing','changed'].includes(item.state) && !this.alreadyAdded(item); }
    togglePicker(item:any) {
        if(this.pickerSaving || !this.pickerEligible(item)) return;
        if(this.picked(item)) this.pickerSelected=this.pickerSelected.filter(x=>x.key!==item.key);
        else {
            if(this.pickerSelected.length+this.draft.selection.length>=200) { this.pickerError='파일·폴더는 최대 200개까지 담을 수 있습니다.'; return; }
            this.pickerSelected=[...this.pickerSelected,{key:item.key,kind:item.kind,name:item.name}];
        }
        this.service.render();
    }
    removePicked(key:string) { this.pickerSelected=this.pickerSelected.filter(x=>x.key!==key); this.service.render(); }
    pickerAll() {
        const items=this.pickerData.items.filter((x:any)=>this.pickerEligible(x));
        return items.length>0 && items.every((x:any)=>this.picked(x));
    }
    togglePickerPage() {
        const items=this.pickerData.items.filter((x:any)=>this.pickerEligible(x));
        if(this.pickerAll()) { const keys=new Set(items.map((x:any)=>x.key)); this.pickerSelected=this.pickerSelected.filter(x=>!keys.has(x.key)); }
        else for(const item of items) if(!this.picked(item)) this.togglePicker(item);
        this.service.render();
    }
    pickerStatus(item:any) {
        if(this.alreadyAdded(item)) return '이미 담은 자료';
        if(item.state==='missing') return '파일 없음';
        if(item.state==='blocked') return '접근 불가';
        if(item.state==='changed') return '원본 변경됨';
        if(item.kind==='folder') return '하위 파일 포함';
        if(item.state==='unregistered') return '등록 필요';
        return item.format || '파일';
    }

}

export default PageKnowledge_graphComponent;